import React, { useEffect, useRef, useState } from "react";
import * as R from "ramda";
import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import parse from "date-fns/parse";

export const DateWithModal = ({ selectedDate, setSelectedDate, isRequired, classToolbar, maxDate = new Date() }) => {
	registerLocale("fr", fr);
	const calendarRef = useRef(null);
	const [date, setDate] = useState({
		selectedDate: !R.isNil(selectedDate) ? selectedDate : new Date(),
	});
	const [dateManualEdit, setDateManualEdit] = useState(false);
	const [manualDate, setManualDate] = useState("");
	const today = new Date();

	useEffect(() => {
		//if (!R.isNil(selectedDate)) {
		setDate({ selectedDate: selectedDate });
		if (R.isNil(selectedDate)) {
			setManualDate("");
		}
		//}
	}, [selectedDate]);

	function capitalize(s) {
		if (typeof s !== "string") return "";
		return s.charAt(0).toUpperCase() + s.slice(1);
	}

	function convertDateToUtc(date) {
		let month = date.getMonth() + 1;
		let monthString = month < 10 ? "0" + month : "" + month;
		let day = date.getDate();
		let dayString = day < 10 ? "0" + day : "" + day;
		return new Date(date.getFullYear() + "-" + monthString + "-" + dayString + "T00:00:00Z");
	}

	function removeSelectedFromCalendar() {
		setTimeout(() => {
			const nodes = window.document.querySelectorAll(".react-datepicker__day--keyboard-selected");
			if (!R.isNil(nodes) && nodes.length > 0) {
				nodes.forEach((element) => {
					element.classList.remove(["react-datepicker__day--keyboard-selected"]);
				});
			}
		}, 0);
	}
	return (
		<div className={classToolbar ? "my-1 input-group btn-dim rounded-max btn-alert" + (!R.isNil(selectedDate) ? " active" : "") : "input-group"}>
			<input
				required={isRequired === true ? true : false}
				type="text"
				className={classToolbar ? "no-outline container-slim form-control bg-none border-none rounded-inherit my-auto small" : "form-control bg-white border-right-0"}
				id="date-modal"
				placeholder="dd/mm/yyyy"
				value={R.isNil(selectedDate) || dateManualEdit === true ? manualDate : selectedDate.toLocaleDateString("fr-FR", { day: "numeric", month: "numeric", year: "numeric" })}
				onFocus={() => {
					if (dateManualEdit === false) {
						setDateManualEdit(true);
						if (!R.isNil(selectedDate)) {
							setManualDate(selectedDate.toLocaleDateString("fr-FR", { day: "numeric", month: "numeric", year: "numeric" }));
						}
					}
				}}
				onBlur={(e) => {
					if (dateManualEdit === true && e.target.value !== "") {
						const inputValue = e.target.value.replaceAll("/", "");
						const parsedDate = parse(inputValue, "ddMMyyyy", new Date());
						if (parsedDate === "Invalid Date") {
							setManualDate("");
							setDate({ ...date, selectedDate: new Date() });
							setDateManualEdit(false);
							setSelectedDate(undefined);
							return;
						}
						if (!R.isNil(parsedDate) && parsedDate !== selectedDate && parsedDate < Date.now() && parsedDate > new Date("01/01/1900")) {
							const utcDate = convertDateToUtc(parsedDate);
							setSelectedDate(utcDate);
							setDate({ ...date, selectedDate: utcDate });
						} else {
							if (!R.isNil(selectedDate)) {
								setManualDate(selectedDate.toLocaleDateString("fr-FR", { day: "numeric", month: "numeric", year: "numeric" }));
							}
						}
					} else {
						setManualDate("");
						setSelectedDate(undefined);
						setDate({ ...date, selectedDate: new Date() });
					}
					setDateManualEdit(false);
				}}
				onChange={(e) => {
					setManualDate(e.target.value);
				}}
			/>
			<div className={classToolbar ? "input-group-prepend rounded-inherit dropdown ml-auto" : "input-group-prepend"}>
				<div className={classToolbar ? "input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" : "input-group-text border-left-0 rounded-right dropdown"}>
					<i className={classToolbar ? "eva eva-calendar-outline align-middle fs-root lh-0 o-100 o-100--hover" : "eva eva-calendar o-30"} role="button" id="dropdownMenuNaissance" data-toggle="dropdown"></i>
					<div className="dropdown-menu dropdown-row dropdown-menu-right shadow-lg rounded-sm" aria-labelledby="dropdownMenuNaissance">
						<div className="dropdown-header gradient-prime">
							{R.isNil(date.selectedDate) ? (
								<>
									<p className="h6 mb-2 o-50"></p>
									<h1 className="h2 font-weight-bolder mb-6"></h1>
								</>
							) : (
								<>
									<p className="h6 mb-2 o-50">{date.selectedDate.getFullYear()}</p>
									<h1 className="h2 font-weight-bolder mb-6">
										{capitalize(date.selectedDate.toLocaleDateString("fr-FR", { weekday: "long" }))}, <br />
										{capitalize(date.selectedDate.toLocaleDateString("fr-FR", { month: "long" })) + date.selectedDate.getDate()}
									</h1>
								</>
							)}
						</div>
						<div className="dropdown-body">
							<div
								className="block"
								onClick={(e) => {
									e.stopPropagation();
									e.nativeEvent.stopImmediatePropagation();
								}}>
								{dateManualEdit === true ? (
									""
								) : (
									<DatePicker
										ref={calendarRef}
										locale="fr"
										placeholderText=""
										showMonthDropdown
										showYearDropdown
										shouldCloseOnSelect={false}
										dateFormat="dd-MM-yyyy"
										selected={date.selectedDate}
										onChange={(startDate) => {
											let utcDate = convertDateToUtc(startDate);
											setDate({ ...date, selectedDate: utcDate });
											setManualDate(utcDate.toLocaleDateString("fr-FR", { day: "numeric", month: "numeric", year: "numeric" }));
										}}
										onMonthChange={() => {
											removeSelectedFromCalendar();
										}}
										onYearChange={() => {
											removeSelectedFromCalendar();
										}}
										maxDate={maxDate}
										inline
										scrollableYearDropdown={true}
										yearDropdownItemNumber={today.getFullYear() - 1900}
									/>
								)}
							</div>
							<div className="grid grid-2">
								<button type="button" className="btn btn-light">
									Annuler
								</button>
								<button
									type="button"
									className="btn btn-info"
									onClick={() => {
										setSelectedDate(date.selectedDate);
									}}>
									Ajouter
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
